module.exports = __webpack_public_path__ + "img/home.a8ed8edc.jpg";